import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Input, Select } from '../../../components';
import { UserService } from '../../../services';
import { PasswordActive, PasswordInactive } from "../../../assets/icons";
import { Constants } from "../../../utils";

const ModalCreateModerator = ({ onClose, onSuccess, initialData }) => {
  const { form, isLoading, onChange, selects, submit } = useForm({ initialData, onClose, onSuccess });
  const [showPassword, setShowPassword] = useState(false);
  const isEdit = !!initialData?.id;

  return (
    <div className="w-[24rem] bg-white rounded-2xl shadow-xl overflow-hidden max-h-[90vh] overflow-y-auto">
      <div className="flex items-center justify-between px-6 py-4">
        <h2 className="text-lg font-bold text-text">{isEdit ? 'Editar' : 'Crear'} Moderador</h2>
        <button
          type="button"
          className="p-1.5 rounded-full hover:bg-gray5 transition-colors"
          onClick={onClose}
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-text">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div className="flex flex-col gap-4 px-6">
        <div>
          <p className="mb-1 text-text">Tipo</p>
          <Select
            label="Tipo"
            items={selects.types}
            value={form.moderator_type_id || ''}
            onValueChange={v => onChange('moderator_type_id', v)}
          />
        </div>
        <Input
          label="Nombre"
          value={form.name || ''}
          onValueChange={v => onChange('name', v)}
        />
        <Input
          label="Correo"
          value={form.email || ''}
          onValueChange={v => onChange('email', v)}
        />

        <div className="col-span-2 mt-2">
          <p className="text-lg font-semibold text-black">Contraseña</p>
        </div>
        <Input
          label="Contraseña"
          type={showPassword ? 'text' : 'password'}
          value={form.password || ''}
          onValueChange={v => onChange('password', v)}
          append={
            <button
              type="button"
              tabIndex="-1"
              onClick={() => setShowPassword(!showPassword)}
              className="text-gray-400"
            >
              <img src={showPassword ? PasswordActive : PasswordInactive} className="w-6 h-6" alt="" />
            </button>
          }
        />
        <Input
          label="Repetir contraseña"
          type={showPassword ? 'text' : 'password'}
          value={form.password_confirmation || ''}
          onValueChange={v => onChange('password_confirmation', v)}
          append={
            <button
              type="button"
              tabIndex="-1"
              onClick={() => setShowPassword(!showPassword)}
              className="text-gray-400"
            >
              <img src={showPassword ? PasswordActive : PasswordInactive} className="w-6 h-6" alt="" />
            </button>
          }
        />
      </div>

      <div className="flex justify-center mt-2 px-6 py-4 gap-3">
        <button
          type="button"
          className="px-6 py-2 bg-gray-200 text-text font-semibold rounded-full hover:bg-gray-300 transition-colors text-sm"
          onClick={onClose}
          disabled={isLoading}
        >
          Cerrar
        </button>
        <button
          type="button"
          className="px-6 py-2 bg-red text-white font-semibold rounded-full hover:bg-gray-800 transition-colors text-sm disabled:opacity-50"
          onClick={submit}
          disabled={isLoading}
        >
          {isLoading ? 'Guardando...' : 'Guardar'}
        </button>
      </div>
    </div>
  );
};

const useForm = ({ initialData, onClose, onSuccess }) => {
  const isEdit = !!initialData?.id;

  const getInitial = (data) => ({
    id: data?.id || '',
    name: data?.person?.name || '',
    moderator_type_id: data?.moderator_type_id || '',
    email: data?.email || '',
    password: '',
    password_confirmation: '',
  });

  const [form, setForm] = useState(() => getInitial(initialData));
  const [selects, setSelects] = useState({
    types: [],
  });
  const [isLoading, setIsLoading] = useState(false);

  const getSelects = async () => {
    try {
      setSelects({
        types: [
          { value: Constants.MODERATOR_TYPE.SUPERVISOR.toString(), label: 'Supervisor' },
          { value: Constants.MODERATOR_TYPE.COORDINATOR.toString(), label: 'Coordinador de mantenimiento' },
        ],
      });

    } catch (error) {
      setSelects({ states: [] });
    }
  };

  const onChange = (target, value) => {
    setForm(s => ({ ...s, [target]: value }));
  };

  const isValidForm = () => {
    const onError = (msg) => {
      toast.error(msg);
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!form.moderator_type_id)
      return onError('El tipo es requerido');

    if (!form.name.trim())
      return onError('El nombre es requerido');

    if (!form.email.trim())
      return onError('El correo electrónico es requerido');

    if (!emailRegex.test(form.email))
      return onError('El correo electrónico no es válido');

    if (!isEdit && !form.password)
      return onError('La contraseña es requerida');

    if (form.password && form.password.length < 6)
      return onError('La contraseña debe tener al menos 6 caracteres');

    if (form.password !== form.password_confirmation)
      return onError('Las contraseñas no coinciden');

    return true;
  };

  const submit = async () => {
    if (!isValidForm()) return;
    setIsLoading(true);
    try {
      if (initialData?.id) {
        await UserService.admin.updateModerator(form);
        toast.success('Moderador actualizado con éxito');
      } else {
        await UserService.admin.createModerator(form);
        toast.success('Moderador creado con éxito');
      }
      onSuccess?.();
      onClose?.();

    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getSelects();
  }, []);

  return {
    form,
    isLoading,
    onChange,
    selects,
    submit,
  };
};

export default ModalCreateModerator;
